import React from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
} from '@material-ui/core'

import './index.scss'

const ConfirmHTO = ({ isOpen, onClose }) => (
    <div className='ConfirmHTO'>
        <Dialog
            classes={{
                root: 'ConfirmSend__root',
            }}
            open={isOpen}
            onClose={() => onClose(false)}
        >
            <DialogTitle>Warning</DialogTitle>
            <DialogContent>
                <p>Are you sure you want to Just save and HTO?</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)}>No, Do not Send</Button>
                <Button color='primary' onClick={() => onClose(true)}>
                    Yes, Send{' '}
                </Button>
            </DialogActions>
        </Dialog>
    </div>
)

export default React.memo(ConfirmHTO)
